module.exports = __webpack_public_path__ + "img/img-04.b8aa60dc.jpg";